export const TranslationsAR = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "اطلب عبر الانترنت",
        cart: "عربة التسوق",
        open_24: "۲٤ساعة",
        closed: "مغلق",
        free: "مجاناً",
        something_went_wrong: "حدث خطأ ما",
        try_again: "أعد المحاولة",
    },
    constants: {
        calendar: {
            days: {
                monday: "الاثنين",
                tuesday: "الثلاثاء",
                wednesday: "الأربعاء",
                thursday: "الخميس",
                friday: "الجمعة",
                saturday: "السبت",
                sunday: "الأحد",
            },
        },
        services: {
            pickup: "بيك أب",
            delivery: "التسليم",
            dine_in: "في الداخل يتناول العشاء",
            table_booking: "حجز طاولة",
        },
        payment: {
            method: {
                cash: "الدفع نقداً",
                card: "الدفع عن طريق البطاقة",
                stripe: "بطاقة الائتمان",
                paypal: "باي بال",
                cardconnect: "بطاقة الائتمان",
                paygate_payweb: "باي جيت باي ويب",
                poli_pay: "بولي باي",
                ipay88: "آي باي ۸ ۸ ",
                bambora_apac: "بامبورا_منطقة آسيا والمحيط الهادئ",
                pesapal: "بيزا بال",
                custom: "مُوصىً عليه",
            },
            backend_method: {
                cash: "الدفع نقداً",
                card: "الدفع عن طريق البطاقة",
                stripe: "سترايب",
                paypal: "باي بال",
                cardconnect: "ربط البطاقة",
                paygate_payweb: "باي جيت باي ويب",
                poli_pay: "بولي باي",
                ipay88: "آي باي ۸ ۸",
                bambora_apac: "بامبورا_منطقة آسيا والمحيط الهادئ",
                pesapal: "بيزابال",
                custom: "العميل",
            },
            status: {
                success: "نجحت العملية",
                pending: "العملية معلّقة",
                error: "حدث خطأ ما",
                refunded: "مستردّ",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "إزالة",
                drop_here: "أرسل ملفاتك هنا أو انقر لتحديد ملف واحد.",
                accepts: "{{أنواع الملفات}} الملفات المقبولة",
                errors: {
                    max_files: "{{عدد}}الحد الأقصى المسموح به لعدد الملفات ",
                    max_size: "كيلوبايت {{كيلوبايتات}}الحد الأقصى لحجم الملف ",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "المتجر مغلق حالياً، ولا يمكن تقديم طلب مستحق في الحال لتناول الطعام داخل المتجر",
            },
            buttons: {
                order: {
                    book_order: "احجز طاولة / اطلب عبر الانترنت",
                    order_online: "اطلب عبر الانترنت",
                    book_table: "احجز طاولة",
                    order: "اطلب",
                    book: "احجز",
                    cart: "عربة",
                    restart: "إعادة بدأ",
                    closed: "المتجر مغلق",
                    not_accepting: "عدم قبول الطلبات",
                },
            },
        },
        modals: {
            auth: {
                login: "تسجيل الدخول",
                register: "سَجّل",
                register_commence: "تابع",
                register_complete: "إنشاء حساب",
                register_confirmation_sent: "تم إرسال رمز تأكيد إلى عنوان بريدك الإلكتروني. يرجى إدخاله أدناه للمتابعة",
                register_confirmation_resent: "تم إرسال رمز التأكيد مرة أخرى، تحقق من البريد الإلكتروني العشوائي لديك أو أعد العملية.",
                register_restart: "إعادة بدأ",
                register_resend_code: "إعادة إرسال الرمز",
                login_placeholder: "البريد الإلكتروني",
                password_placeholder: "كلمة المرور",
                confirm_password_placeholder: "تأكيد كلمة المرور",
                confirmation_code_placeholder: "رمز التأكيد للبريد الإلكتروني",
                accept_terms: "شروط القبول والأحكام",
                accept_terms_view: "انظر",
                login_facebook: "تسجيل الدخول باستخدام حسابك على فيسبوك",
                login_google: "تسجيل الدخول باستخدام حساب جوجل الخاص بك",
                benefits: "قم بتسجيل الدخول إلى حسابك أو إنشاء حساب لحفظ جميع الطلبات الخاصة بك.",
                logged_in: "تم تسجيل الدخول بنجاح.",
                logged_out: "تم تسجيل الخروج",
                password_reset: {
                    init_button: "إرسال بريد إعادة تعيين كلمة المرور.",
                    init_success: "تم إرسال رابط إعادة تعيين كلمة المرور الخاصة بك إلى بريدك الإلكتروني.",
                    complete_button: "إعادة تعيين كلمة المرور.",
                    complete_success: "تم إعادة تعيين كلمة المرور بنجاح، قم بتسجيل الدخول باستخدام كلمة المرور الجديدة",
                    forgot_password_text: "هل نسيت كلمة المرور؟",
                    forgot_password_link: "أعد تعيين كلمة المرور الخاصة بك.",
                    remember_password_text: "هل تريد تذكّر كلمة المرور؟",
                    remember_password_link: "تراجع",
                    invalid_title: "إعادة تعيين كلمة المرور غير صحيحة",
                    invalid_description: "رابط إعادة تعيين كلمة المرور هذا غير صالح ، اطلب رابطًا جديدًا بدلاً من ذلك.",
                    invalid_link: "انتقل إلى تسجيل الدخول",
                    title: "إعادة تعيين كلمة المرور.",
                    description: "أدخل كلمة مرور جديدة لحسابك",
                },
                error_generic: "حدث خطأ ما، يرجى المحاولة مرة أخرى أو الاتصال بنا.",
                error_accept_terms: "يرجى الموافقة على الشروط والأحكام.",
                error_password_length: "يجب أن تتكون كلمة المرور على الأقل من ٦ حروف.",
                error_social: "حدث خطأ ما، يرجى المحاولة مرة أخرى أو الاتصال بنا.",
                error_confirmation_code: "رمز التأكيد غير صالح.",
                error_invalid_code: "رمز التأكيد غير صالح.",
                error_exists: "اسم المستخدم موجود من قبل.",
                error_invalid_email_pass: "خطأ في إدخال عنوان البريد الإلكتروني أو كلمة المرور.",
                error_password_no_match: "لا تتطابق كلمات المرور مع بعضها.",
                error_user_not_found: "لا يوجد اسم مستخدم بهذا البريد الإلكتروني.",
                error_invalid_email: "عنوان البريد الإلكتروني هذا غير صالح.",
                error_invalid_reset_token: "رابط إعادة تعيين كلمة المرور غير صالح، اطلب رابطاً آخر.",
            },
            booking: {
                form: {
                    name: "الاسم الكامل:",
                    email: "عنوان البريد الإلكتروني",
                    phone: "رقم الهاتف",
                    number_of_people: "عدد الأشخاص",
                    number_of_people_max: "الحد الأقصى لعدد الأشخاص",
                    number_of_people_min: "الحد الأدنى لعدد الأشخاص ",
                    number_of_people_max_min: "يتراوح عدد الأشخاص ما بين (الحد الأقصى) إلى (الحد الأدنى)",
                    notes: "ملاحظات/ الطلبات الخاصة",
                    submit: "إرسال طلب الحجز",
                    email_optional: "(اختياري)",
                    date: "التاريخ",
                    duration: "المدة",
                    seating: "الأوقات المتاحة",
                    number_of_guests: "عدد الضيوف",
                    notes_placeholder: "الحساسية، المناسبة، تفضيل الجلوس",
                    reserving: "جارٍ الحجز...",
                    reserve_table: "احجز طاولة",
                    please_choose_a_date_and_time: "يُرجى اختيار تاريخ ووقت.",
                    invalid_people: "يجب أن يكون عدد الأشخاص بين {{min}} و{{max}}.",
                    party_size_max_fallback: "الحد الأقصى المسموح",
                    loading_available_times: "جارٍ تحميل الأوقات المتاحة…",
                    select_a_date_to_see_available_times: "اختر تاريخًا لعرض الأوقات المتاحة.",
                    no_times_available_for_this_date: "لا توجد أوقات متاحة لهذا التاريخ. يُرجى اختيار يوم آخر.",
                    shift: "فترة",
                    service_times: "أوقات الخدمة",
                    new_shift: "فترة جديدة",
                    time: "وقت",
                    times: "أوقات",
                    unavailable: "غير متاح",
                    available: "متاح",
                    required_name: "يُرجى إدخال اسمك.",
                    required_phone: "يُرجى إدخال رقم هاتفك.",
                    required_email: "يُرجى إدخال بريدك الإلكتروني.",
                    invalid_email: "يُرجى إدخال بريد إلكتروني صالح.",
                    required_terms: "يُرجى قبول الشروط قبل الحجز.",
                    missing_custom_fields: "يُرجى الإجابة عن جميع الأسئلة المطلوبة.",
                    reservation_is_unavailable: "الحجز غير متاح.",
                    please_contact_the_restaurant_directly: "يُرجى التواصل مع المطعم مباشرة.",
                    almost_done: "أوشكنا على الانتهاء",
                    your_details: "بياناتك",
                    tell_us_who_s_coming: "أخبرنا بمن سيحضر حتى نتمكن من تأكيد حجزك.",
                    book_your_table: "احجز طاولتك",
                    choose_a_time_that_works_for_you: "اختر وقتًا يناسبك.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "أرسل طلب الحجز وسيتولى المطعم الباقي.",
                    select_date: "اختر التاريخ",
                    standard: "افتراضي",
                    minutes: "دقيقة",
                    next: "التالي →",
                    back: "← رجوع",
                    accept_terms: "أوافق على الشروط والأحكام.",
                    info_1: "ستتلقى إشعاراً عبر البريد الإلكتروني بقبول أو رفض حجزك.",
                },
                errors: {
                    not_found: "الحجز غير موجود. ربما تم حذفه",
                    generic: "حدث خطأ ما، قم بتحديث الصفحة أو الاتصال بنا.",
                    something_went_wrong: "حدث خطأ ما.",
                    accept_terms: "يرجى الموافقة على الأحكام والشروط.",
                    required_phone: "يرجى إدخال رقم هاتفك.",
                    required_email: "يرجى إدخال بريدك الإلكتروني.",
                    required_name: "يرجى إدخال اسمك.",
                    invalid_email: "يرجى إدخال بريد إلكتروني صحيح.",
                    invalid_phone: "يرجى إدخال رقم هاتف صحيح.",
                    invalid_people: "عدد الأشخاص غير صالح",
                    booking_capacity_threshold: "هذا الوقت محجوز بالكامل. يُرجى تجربة وقت آخر.",
                    slot_unavailable: "هذا العدد من الأشخاص محجوز بالكامل. يُرجى تجربة وقت آخر.",
                    booking_date_paused: "الحجوزات متوقفة لهذا التاريخ. يُرجى اختيار يوم آخر.",
                    invalid_table_assignment: "هذه الطاولات لا تتسع لمجموعتك. يُرجى اختيار وقت آخر.",
                    exceeded_order_limit: "طلبات حجز كثيرة جدًا. يُرجى المحاولة لاحقًا.",
                    validation_failed_recaptcha_v3: "تم رصد حركة غير معتادة. هل تستخدم VPN؟ أكمل التحقق أعلاه وحاول مرة أخرى.",
                    validation_failed_recaptcha_v2: "تعذّر بدء الحجز. يُرجى المحاولة مرة أخرى أو استخدام طريقة أخرى. إذا كنت تستخدم VPN، جرّب إيقافه أولًا.",
                    booking_already_exists: "تم إرسال هذا الحجز مسبقًا. تحقق من بريدك الإلكتروني أو افتح رابط الحجز.",
                    invalid_party_size: "يُرجى اختيار عدد صالح من الأشخاص.",
                    invalid_request: "طلب غير صالح. يُرجى تحديث الصفحة والمحاولة مرة أخرى.",
                    table_booking_unavailable: "حجز الطاولات غير متاح.",
                },
            },
            cart: {
                title: "عربة",
                proceed_to_checkout: "تابع لفحص المنتج",
                edit_dish: "تعديل",
                remove_dish: "إزالة",
                no_items_1: "لا يوجد عناصر في عربة التسوق",
                no_items_2: "أضف بعض العناصر أولاً للمتابعة",
                free_delivery_notice: "توصيل مجاني للطلبات التي تزيد عن (القيمة، العملة).",
                errors: {
                    min_order_promo: "الحد الأدنى المطلوب لقيمة عربة التسوق (القيمة، العملة) قبل تطبيق هذا العرض الترويجي",
                    min_order_delivery: "الحد الأدنى لقيمة عربة التسوق (القيمة، العملة) للتسليم",
                },
                promo: {
                    heading: "الرمز الترويجي",
                    placeholder: "أدخل الرمز الترويجي الخاص بك",
                    add: "أضف رمزاً",
                    title: "تم إضافة (اسم) العرض الترويجي إلى عربة التسوق",
                    fixed_discount: "خصم (القيمة، العملة)",
                    percent_discount: "خصم (قيمة)%",
                    added_to_cart: "تم إضافة العرض الترويجي إلى عربة اتسوق.",
                    errors: {
                        not_found: "لم يتم العثور على العرض الترويجي.",
                        disabled: "تم تعطيل العرض الترويجي.",
                        not_available: "العرض الترويجي غير متوفر حاليا.ً",
                        logged_in_only: "يجب تسجيل الدخول لاستخدام هذا العرض الترويجي.",
                        already_used: "لقد استخدمت هذا العرض الترويجي بالفعل. ",
                        invalid: "لم يعد هذا العرض الترويجي صالحًا",
                        invalid_service: "هذا العرض غير صالح للخدمة التي اخترتها",
                        later_only: "صالح للطلبات المسبقة فقط.",
                        now_only: "صالح فقط للطلبات المستحقة على الفور وليس للطلبات المسبقة",
                        generic: "عذرًا... حدث خطأ ما وتم تسجيله",
                        dishes_required_multi: " سيتم تطبيق هذا العرض الترويجي فقط عند إضافة أطباق معينة إلى عربة التسوق الخاصة بك ",
                        dishes_required_single: "سيتم تطبيق هذا العرض الترويجي فقط على (الطبق) '"
                    },
                },
                tip: {
                    title: "اطلب إكرامية",
                    placeholder: "أضف إكرامية طلب",
                },
            },
            checkout: {
                title: "فحص",
                subtitle: "قم بتأكيد تفاصيل طلبك",
                details: {
                    service: "الخدمة",
                    due: "مستحق",
                    due_now_asap: "الآن، في أقرب وقت ممكن",
                    address: "عنوان التسليم",
                    total: "المجموع",
                    table: "الطاولة",
                    store_location: "عنوان المتجر",
                },
                customer: {
                    title: "الزبون",
                    subtitle: "تسجيل الدخول لحفظ طلبك والتفاصيل الخاصة به",
                    button: "تسجيل الدخول",
                    name: "الاسم الكامل",
                    email: "عنوان البريد الإلكتروني",
                    phone: "رقم الهاتف",
                    phone_important: "رقم الهاتف (هام)",
                    notes: "ملاحظات خاصة بالطلب",
                    delivery_notes: "تعليمات التوصيل/ ملاحظات خاصة بالطلب",
                    optional: "اختياري"
                },
                payment: {
                    title: "طريقة الدفع",
                },
                accept_terms: "الموافقة على الشروط والأحكام",
                accept_terms_view: "انظر",
                processing_order: "تجهيز الطلب",
                warning: {
                    different_payment_currency: "تتوفر أسعار المتجر بعملة المتجر بينما تتم عملية الدفع من خلال عملة الدفع.",
                    closing_soon: "سيتم الإغلاق قريباً، يجب تقديم الطلبات في (قَدر) من الدقائق.",
                    closed: "عذرًا ، تم إغلاق هذه الخدمة ولا يتم قبول الطلبات.",
                    expired: "لا يمكننا تلبية طلبك في الوقت الذي حددته. يرجى اختيار تاريخ لاحق أو وقت آخر.",
                },
                errors: {
                    stripe_generic: "خطأ في بطاقة الائتمان، حاول مرةً أخرى أو جرب طريقة أخرى.",
                    stripe_loading_fail: "خطأ في تحميل نموذج الدفع، يرجى المحاولة مرة أخرى.",
                    something_went_wrong: "حدث خطأ ما.",
                    paypal_generic: "حدث خطأ ما من جانب باي بال، حاول مرة أخرى، أو اختر طريقة أخرى للدفع.",
                    payment_fail: "فشل عملية الدفع، يرجى المحاولة مرة أخرى، أو حدّد طريقة أخرى للدفع.",
                    payment_cancelled: "تم إلغاء عملية الدفع، يرجى المحاولة مرةً أخرى أو حدّد طريقة أخرى للدفع.",
                    payment_error: "تعذرت معالجة عملية الدفع عبر الانترنت، حاول مرةً أخرى أو اختر طريقة أخرى للدفع.",
                    payment_declined: "تم رفض عملية الدفع.",
                    card_declined: "تم رفض بطاقتك، وتعذرت معالجة عملية الدفع.",
                    promo_max_uses_exceeded: "لقد وصل رمز العرض الترويجي هذا إلى حد الاستخدام ولم يعد متاحًا.",
                    store_closed: "المتجر مغلق، وتوقف عن قبول الطلبات.",
                    accept_terms: "يرجى الموافقة على الشروط والأحكام.",
                    required_payment: "الرجاء اختيار طريقة للدفع.",
                    required_phone: "يرجى إدخال رقم هاتفك.",
                    required_email: "يرجى إدخال بريدك الإلكتروني.",
                    required_name: "يرجى إدخال اسمك.",
                    invalid_email: "يرجى إدخال عنوان بريد إلكتروني صحيح.",
                    invalid_phone: "يرجى إدخال رقم هاتف صحيح.",
                    invalid_cc_number: "رقم بطاقة الائتمان الخاصة بك غير صالح.",
                    retry_cc_number: " حدث خطأ ما، أعد إدخال رقم بطاقة الائتمان الخاصة بك وحاول مرة أخرى. ",
                    closed: "المتجر مغلق/ يتم إغلاقه الآن، ولا يقبل الطلبات.",
                    promo_login_required: "يجب تسجيل الدخول لاستخدام هذا العرض الترويجي.",
                    promo_used: "لقد استخدمت هذا العرض الترويجي بالفعل.",
                },
                button: {
                    continue: "تابع للدفع.",
                    place_order: "تقديم الطلب.",
                },
            },
            customer: {
                age_v: {
                    title: "التحقق من العمر.",
                    required_for_items: "معلومات مطلوبة لإتمام طلب عناصر معينة.",
                    min_age: "الحد الأدنى للسن (العمر) بالسنوات.",
                    est_time: "تقدير وقت التحقق (الوقت) بالساعات.",
                    upload_description: "حَمّل بطاقة هويتك أدناه للتحقق. سيتم إشعارك عبر البريد الإلكتروني بمجرد التحقق منه، حمّل صورتين على أن يكون الحد الأقصى لحجم كل منهما ۲ ميجا بايت.",
                    pending_description_1: "شكراً لك على إرسال الوثائق الخاصة بك. سيتم إعلامك من خلال البريد الإلكتروني عند الموافقة.",
                    pending_description_2: "قم بتحديث الصفحة لتحديث حالة التحقق الخاصة بك. تقدير وقت التحقق(الزمن) بالساعات.",
                    approved_description: "تم التحقق من حسابك ويمكنك الطلب من القوائم المحددة.",
                    rejected_description: "تم رفض بطاقة هويتك. إذا كنت ترغب في المحاولة مرة أخرى، يرجى إعادة تحميل الهوية الخاصة بك. ",
                    upload: "تحميل",
                    reupload: "إعادة تحميل الوثائق",
                    go_back: "تراجع",
                    view_document: "عرض المستند (الرقم)",
                    status: {
                        unverified: "لم يتم التحقق منه",
                        pending: "في انتظار الموافقة",
                        approved: "تم التحقق بنجاح",
                        rejected: "تم الرفض",
                    },
                },
                headings: {
                    sessions: "جلسات",
                    orders: "طلب",
                    spend: "أنفق",
                    order_history: "محفوظات الطلبات",
                    loyalty_points: "نقاط الولاء",
                },
            },
            custom_payment: {
                title: "(الاسم) نموذج الدفع",
                description: "لقد وصلت إلى نموذج الدفع عبر الإنترنت. يُرجى إكمال الحقول أدناه لإجراء عملية الدفع. إذا لم يتم إدخال المبلغ، فسيتم حفظ بياناتك ولن يتم تحصيل رسوم منك.",
                disabled: "لم يتم ضبط صفحة الدفع عبر الإنترنت هذه بشكل صحيح، يرجى الاتصال بمالك الموقع لتصحيح المشكلة.",
                success: "تمت معالجة عملية الدفع التي أجريتها بنجاح. وتم حفظ البيانات الخاصة بك. شكراً لك.",
                back: "الرجوع إلى الصفحة الرئيسية",
                fields: {
                    name: "الاسم الكامل",
                    email: "عنوان البريد الإلكتروني",
                    reference: "علامة الدفع",
                    amount: "القيمة (بالدولار)",
                    name_on_card: "الاسم على البطاقة",
                    submit: "إرسال الدفع",
                },
                warning: {
                    currency: "ملحوظة: مبلغ الدفع (حقيقي) وليس (متأخر السداد)",
                },
                errors: {
                    generic: "حدث خطأ ما، حاول مرة أخرى أو اتصل بنا",
                    stripe_generic: "خطأ في بطاقة الائتمان، قم بتحديث الصفحة وحاول مرة أخرى",
                    payment_fail: "فشل عملية الدفع، يرجى المحاولة مرة أخرى أو تحديد طريقة دفع مختلفة. ",
                    payment_cancelled: "تم إلغاء عملية الدفع، يرجى المحاولة مرة أخرى أو تحديد طريقة دفع مختلفة. ",
                    payment_error: "حدث خطأ ما أثناء معالجة عملية الدفع عبر الإنترنت، حاول مرة أخرى أو اختر طريقة دفع مختلفة. ",
                    payment_declined: "تم رفض طريقة الدفع التي أجريتها.",
                    card_declined: "تم رفض بطاقتك وتعذرت معالجة عملية الدفع",
                    promo_max_uses_exceeded: "لقد وصل رمز العرض الترويجي هذا إلى حد الاستخدام ولم يعد متاحًا.",
                },
            },
            dish: {
                add: "أضف إلى عربة التسوق.",
                edit: "تحديث عنصر",
                notes: "تعليمات خاصة...",
                ingredients: {
                    title: "المكونات",
                    uncheck_remove: "إلغاء تحديد العناصر للإزالة",
                },
                ingredients_title: "المكونات",
                combo: {
                    choose_dish: "اختر طبقاً",
                },
                option_sets: {
                    conditions: {
                        select_one: "حدد واحداً (مطلوب)",
                        select_one_optional: "اختر واحداً (اختياري)",
                        select_between: "اختر ما بين (الحد الأدنى) و (الحد الأقصى) (مطلوب).",
                        select_at_least: "حدد على الأقل (الكمية) (مطلوب).",
                        select_up_to: " تحديد ما يصل إلى (كمية) (اختياري)",
                        select_multiple: "تحديد متعدد (اختياري)",
                        free_amount: "/ المختارة (المفضلة) (الكمية) الأولى مجاناً",
                    },
                },
                error: "يرجى تصحيح أي خيارات باللون الأحمر.",
                added_to_cart: "العناصر المضافة إلى عربة التسوق.",
            },
            map: {
                zone_fee: "رسوم التوصيل",
                view_in_google: "عرض في خرائط جوجل.",
            },
            portal_go_back: {
                title: " العودة إلى البحث عن المطاعم؟",
                description: "ستفقد أي عناصر في سلة التسوق الخاصة بك.",
                cancel: "إلغاء",
                proceed: "تراجع",
            },
            order: {
                config: {
                    services: {
                        title: "اختر خدمة",
                        table_booking: "حجز طاولة",
                    },
                    address_custom: {
                        input_placeholder: "أدخل عنوانك",
                    },
                    address: {
                        input_placeholder: "ابحث عن عنوان التوصيل الخاص بك",
                        extras_placeholder: "اختياري: رقم الوحدة ، اسم المبنى ، إلى آخره ...",
                        search_placeholder: "ابحث عن عنوانك.",
                        not_found: "عنوان التوصيل غير موجود أو غير صالح ، حاول مرة أخرى.",
                        not_delivering: "لا نقوم حاليًا بالتوصيل إلى هذا العنوان",
                        not_in_range: "إن عنوانك ليس في نطاق موقع متجرنا.",
                        not_in_zone: "عنوانك ليس ضمن منطقة التوصيل النشطة",
                    },
                    datetime: {
                        title: "متى تريد تنفيذ طلبك؟",
                        due_now: "الآن",
                        due_later: "لاحقاً",
                        service_not_available: "عذراً، لا نقبل طلبات حالياً (خدمة)",
                        currently_closed: "(الخدمات) مغلقة حالياً ولكن يمكنك الطلب لاحقاً.",
                        due_unavailable: "غير متاح",
                        due_closed: "مغلق",
                        select_date: "اختر تاريخاً",
                        select_time: "اختر الوقت",
                        select_order_date: "حدد تاريخ طلبك",
                        select_order_time: "حدد وقت الطلب الخاص بك",
                        select_booking_date: "حدد تاريخ الحجز الخاص بك",
                        select_booking_time: "حدد وقت الحجز الخاص بك",
                        no_times_available: "لا توجد أوقات متاحة للاختيار من بينها",
                        date_today: "(اليوم)",
                        date_closed: "مغلق",
                        date_bookings_paused: "(الحجوزات متوقفة)",
                        time_slot_closed: "مغلق",
                    },
                    number_of_people: {
                        placeholder: "عدد الأشخاص",
                    },
                    table: {
                        select: "حدد طاولة",
                        select_popup_title: "حدد الطاولة الخاصة بك",
                        password: "كلمة مرور الطاولة",
                        password_warning: "أدخل كلمة مرور الطاولة للمتابعة",
                    },
                    warning: {
                        closed: "عذرا، المتجر مغلق حالياً / لا نقبل أي طلبات",
                        not_available: "عذرًا ، لا نقبل أي طلبات حالياً.",
                    },
                    start_button: "بدء الطلب",
                },
                history: {
                    invalid: "لا يصلح لإعادة الطلب حيث تم تعديل بعض العناصر المطلوبة أو العناصر التي لم تعد متاحة.",
                },
                reorder: {
                    title: "إعادة ترتيب سريع",
                    description: "اطلب العناصر بسهولة من طلباتك السابقة.",
                },
            },
            receipt: {
                errors: {
                    not_found: "لم يتم العثور على الطلب، قم بتحديث الصفحة وحاول مرة أخرى.",
                    booking_not_found: "الحجز غير موجود. ربما تم حذفه",
                    generic: "حدث خطأ ما، قم بتحديث الصفحة أو اتصل بنا. ",
                },
                connection: {
                    connected: "تحديثات الوقت الحقيقي",
                    connecting: "يتم الاتصال بالتحديثات في الوقت الحقيقي",
                    disconnected: "تم قطع التحديثات في الوقت الحقيقي",
                },
            },
            warnings: {
                logout: {
                    pretitle: "تحذير",
                    title: "تسجيل الخروج",
                    body: "سيؤدي تسجيل الخروج إلى إزالة أي عناصر تمت إضافتها إلى عربة التسوق الخاصة بك.",
                    cancel: "إلغاء",
                    proceed: "تابع",
                },
                order_restart: {
                    warning: "تحذير",
                    title: "تغيير تفاصيل الطلب",
                    body: "سيؤدي تغيير تفاصيل طلبك إلى إزالة العناصر الموجودة في عربة التسوق الخاصة بك فقد تصبح بعض الأطباق غير متوفرة ",
                    cancel: "إلغاء",
                    proceed: "تابع",
                },
                order_expired: {
                    subtitle: "هام",
                    title: "تم تغيير الطلب إلى مستحق على الفور",
                    description: "لم يعد الوقت المحدد للطلب بعيداً الآن. ولهذا تم تعديل طلبك إلى مستحق فوراً/ في أقرب وقت ممكن.",
                    button: "موافق",
                },
                order_expiring: {
                    subtitle: "هام",
                    title: "تنتهي مهلة الطلب قريباً",
                    description: "يجب تقديم طلبك قبل (الوقت، الزمن من وقت تسجيله) وإلا فلن يكون صالحاً.",
                    button: "موافق",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "زائر",
                login: "تسجيل الدخول",
                login_signup: "تسجيل الدخول/ التوقيع",
                logout: "تسجيل الخروج",
            },
            menus: {
                info: {
                    no_menus: "لا يوجد قوائم متاحة حالياً.",
                    restrictions: "القيود على القائمة",
                    not_available: "القائمة غير متوفرة حالياً.",
                    unavailable: {
                        times: "القائمة غير متوفرة، متطلبات طلبك لا تتطابق مع أدناه.",
                        services: "القائمة غير متوفرة، متطلبات طلبك لا تتطابق مع أدناه",
                        hours: "القائمة غير متوفرة، ساعات طلبك ليست ضمن ساعات هذه القوائم المتوفرة.",
                        pre_order: "القائمة غير متوفرة ، طلبك لا يتطابق مع متطلبات الطلب المسبق.",
                        age: "القائمة غير متوفرة، يجب تسجيل الدخول باستخدام حساب تم التحقق فيه من العمر للطلب من هذه القائمة.",
                    },
                    services: {
                        title: "متطلبات الطلب",
                        pickup: "الشاحنات الصغيرة",
                        delivery: "عمليات التسليم",
                        dine_in: "يتناول العشاء في الداخل",
                    },
                    times: {
                        now: "لا توجد طلبات مسبقة",
                        later: "طلبات مسبقة فقط",
                    },
                    hours: {
                        title: "الساعات المتاحة",
                    },
                    preorder: {
                        title: "متطلبات الطلبات المسبقة",
                        days_in_advance: "يجب تقديم الطلب مقدماً قبل (أيام).",
                        cutoff_time: "آخر موعد للاستلام اليوم الأخير في (الوقت، من الساعة...إلى...",
                    },
                    age_restricted: {
                        title: "التقيد بعمر معين",
                        approved: "تم التحقق من حسابك ويمكنك الطلب من هذه القائمة.",
                        rejected: "مطلوب التحقق من السن لتقديم الطلب. قم بإنشاء حساب وتحميل هويتك",
                    },
                },
                search: {
                    title: 'بحث',
                    no_result: 'لم يتم العثور , حاول مرة أخرى',
                    placeholder: 'بحث'
                }
            },
            info: {
                location: {
                    title: "الموقع",
                    view_map: "عرض الخريطة",
                    phone: "الهاتف",
                },
                hours: {
                    title: "ساعات العمل",
                    title_special: "ساعات العمل الخاصة",
                },
                services: {
                    title: "الخدمات",
                    notes: "ملاحظات",
                    delivery: {
                        ranges: "نطاقات التوصيل",
                        zones: "مناطق التوصيل",
                        view_zones: "عرض المناطق على الخريطة",
                        fee: "رسوم التوصيل",
                        fee_short: 'رسوم',
                        fee_varies: "تتفاوت، يظهر ذلك في عربة التسوق",
                        min_order: "الحد الأدنى للطلب",
                        min_order_short: 'حد أدنى',
                        no_min_order: "لا يوجد حد أدنى للطلب",
                        free_amount: "التوصيل مجاني للطلبات التي تبلغ قيمتها",
                    },
                },
            },
            contact: {
                title: "اتصل بنا",
                name: "الاسم",
                email: "البريد الإلكتروني",
                phone: "رقم الهاتف",
                message: "أدخل رسالتك...",
                send: "أرسل رسالتك",
                success: "تم إرسال رسالتك بنجاح",
                error: "حدث خطأ ما، حاول مرة أخرى أو حاول في وقت لاحق",
            },
            footer: {
                powered_by: "يتم تشغيله بواسطة",
                terms_and_conditions: "الشروط والأحكام",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: "إيصال الحجز",
            details: {
                datetime: "الحجز لصالح",
                number_of_people: "عدد الأشخاص",
                placed: "مُثبّت",
                updated: "آخر تحديث",
                notes: "ملاحظات",
                name: "الاسم",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                store_address: "عنوان المتجر",
            },
            status_update: {
                body: 'تم تحديث حالة الحجز الخاصة بك إلى (الحالة)',
            },
            email_status_update_customer: {
                subject: 'حجز #{{number}} – {{subjectLabel}}',
                body: 'حجزك #{{number}} في {{store}} أصبح الآن {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'طلب #{{number}} – {{subjectLabel}}',
        header: 'وقت تجهيز محدّث',
        title: 'وقت تجهيز محدّث',
        order_number: 'رقم الأمر: {{number}}',
        description: 'سيكون طلبك جاهزًا في {{time}}.',
        order_time_updated_to: 'تم تحديث وقت طلبك.',
        powered_by: 'مشغل بواسطة {{name}}',
        button_text: 'ترتيب المسار',
        subject_label: 'وقت تجهيز محدّث',
        subject_label_delivery: 'وقت توصيل محدّث',
        body_ready: 'سيكون طلبك جاهزًا في {{time}}.',
        body_delivery: 'سيتم توصيل طلبك في {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: "الوقت المقدر للتسليم",
            est_driver_pickup_time: "الوقت المقدر لانصراف السائق",
            est_delivery_time: "الوقت المقدر للتوصيل",
            tab_details: "التفاصيل",
            tab_dishes: "الأطباق",
            details: {
                status: "الحالة",
                placed: "مُثبّت",
                due: "مستحق",
                due_asap: "الآن / في أقرب وقت ممكن",
                last_updated: "آخر تحديث",
                total: "إجمالي",
                type: "النوع",
                table: "الجدول",
                number_of_people: "عدد الأشخاص",
                payment_method: "طريقة الدفع",
                payment_status: "حالة الدفع",
                payment_currency: "عملة الدفع",
                notes: "ملاحظات",
                name: "الاسم",
                email: "البريد الإلكتروني",
                phone: "الهاتف",
                distance: "المسافة",
                driving_time: "مدة القيادة",
                delivery_zone: "المنطقة",
                delivery_address: "عنوان التسليم",
                delivery_tracking: "متابعة التسليم",
                delivery_tracking_link: "رابط التتبع الفوري",
                tookan_status: " حالة Tookan ",
                tookan_status_failed_book: "فشل حجز التسليم",
                tookan_status_failed_update: "فشل تحديث التسليم",
                tookan_status_success: "محجوز للتسليم",
                store_address: "عنوان المتجر",
            },
            dishes: {
                headings: {
                    quantity: "الكمية",
                    item: "عنصر",
                    price: "السعر",
                },
                notes: "ملاحظات",
                remove_ingredients: "إزالة المكونات",
            },
            status_update: {
                title: "تحديث الطلب (العدد)",
                body: "تم تحديث حالة طلبك إلى (الحالة)",
            },
            wait_time_update: {
                title: "تم تحديث (رقم) الطلب",
                body: "تم تحديث وقت استحقاق الطلب",
            },
            delivery_update: {
                title: "تم تحديث (رقم) الطلب",
                body: "تم حجز طلبك للتسليم. انظر رابط التتبع في الوقت الحقيقي",
            },
            payment_status_update: {
                title: "Order {{number}} Updated",
                body: "Your order payment status has been updated.",
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "ترتيب المسار",
                track_delivery_button_text: "تسليم المسار",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "ترتيب المسار",
                track_delivery_button_text: "تسليم المسار",
            },
        },
        totals: {
            tax: "(%{{percent}}) {{name}}",
            tax_in_prices: "سعر الشركة (%{{percent}}) {{name}}",
            fee: "(%{{percent}} + {{value, currency}}) {{name}}",
            fee_percent: "(%{{percent}}) {{name}}",
            fee_fixed: "{{name}}",
            delivery_fee: "رسوم التسليم",
            promo: "(%{{percent}} + {{value, currency}}) {{name}} :خصم",
            promo_percent: "(%{{percent}}) {{name}} :خصم",
            promo_fixed: "{{name}} :خصم",
            promo_none: "{{name}} :خصم",
            cart: "عربة التسوق",
            tip: "اطلب إكرامية",
            total: "المجموع",
        },
        status: {
            unconfirmed: "غير مؤكد",
            awaiting_payment: "انتظار الدفع",
            confirmed: "مؤكد",
            ready: "جاهز",
            on_route: "على الطريق",
            complete: "مكتمل",
            cancelled: "ملغي",
            seated: "تم الجلوس",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "غير متوفر",
                },
            },
            dish: {
                no_stock: "نفاد المخزون",
                not_available: "غير متوفر",
            },
        },
    },
};
//# sourceMappingURL=ar.js.map